import styled from 'styled-components'

export const Form = styled.form`
  padding: 13.25px;
`
